<template>
  <!--精品课程-->
  <div class="nc_course">
    <div class="nc_title">
      <p class="nc_title_L">精品课程</p>
      <p class="nc_title_S"><span>成都中医药大学 — 为您提供最优课程</span></p>
      <p class="nc_title_more"><router-link :to="{ path: '/perfectCourseList', query: { perfectPosition: perfectPosition}}" >[ 查看更多精品课程... ]</router-link></p>
    </div>
    <div class="ncc_main">
      <ul>
        <li v-for="(item,index) in perfectCourseList" :class="[(index+1)%4==0 ? 'mr-0' : '']">
          <router-link target="_blank" :to="{ path: '/videoPlayer', query: { cId: item.id, p: true }}"  :title="item.name" class="nccm_pic"><img :src="item.imageUrl" width="196" height="133"></router-link>
          <router-link target="_blank" :to="{ path: '/videoPlayer', query: { cId: item.id, p: true }}"  :title="item.name" class="nccm_text textover">{{item.name}}</router-link>
          <router-link target="_blank" :to="{ path: '/videoPlayer', query: { cId: item.id, p: true }}"  :title="item.name" class="nccm_disk"><strong>{{item.name}}</strong><br><br>{{item.ybsRbacUser.nickName}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import {listPerfectCourse} from '../api/api';
  export default {
    components: {},
    props: {
      perfectPosition: {
        type: String,
        default: function () {
          return "14,null;"
        }
      },
      orPerfectPosition:{
        type: String,
        default: function () {
          return ''
        }
      }
    },
    data () {
      return {
        perfectCourseList: null
      }
    },
    mounted () {
      listPerfectCourse({
        perfectPosition: this.perfectPosition,
        orPerfectPosition:this.orPerfectPosition,
        orderPerfectSort: true,
        pageNum: 1,
        pageSize: 8
      }).then((response) => {//获取精品课程
        this.perfectCourseList = response.data.data.list;
      })
    },
    computed: {},
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PerfectCourseSimpleList.vue